import {useContext} from 'react'
import {SurveyContext} from '../../utils/context'
import styled from "styled-components";
import {colors} from "../../utils/colors";
import {useFetch, useTheme} from "../../utils/hooks";
import {ErrorWrapper, Loader, StyledLink} from "../../utils/styles/Atoms";

const ResultsContainer = styled.div<{ $theme: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 60px 90px;
  padding: 30px;
  background-color: ${({$theme}) =>
          $theme === 'light' ? colors.light : colors.dark};
`

const ResultsTitle = styled.h2<{ $theme: string }>`
  color: ${({$theme}) => ($theme === 'light' ? '#000000' : '#ffffff')};
  font-weight: bold;
  font-size: 28px;
  max-width: 60%;
  text-align: center;

  & > span {
    padding-left: 10px;
  }
`

const DescriptionWrapper = styled.div`
  padding: 60px;
`

const JobTitle = styled.span<{ $theme: string }>`
  color: ${({$theme}) =>
          $theme === 'light' ? colors.primary : colors.backgroundLight};
  text-transform: capitalize;
`

const JobDescription = styled.div<{ $theme: string }>`
  font-size: 18px;

  & > p {
    color: ${({$theme}) => ($theme === 'light' ? colors.secondary : '#ffffff')};
    margin-block-start: 5px;
  }

  & > span {
    font-size: 20px;
  }
`

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
`

function formatFetchParams(answers) {
    const answerNumbers = Object.keys(answers)

    return answerNumbers.reduce((previousParams, answerNumber, index) => {
        const isFirstParam = index === 0
        const separator = isFirstParam ? '' : '&'
        return `${previousParams}${separator}a${answerNumber}=${answers[answerNumber]}`
    }, '')
}


export function Results() {

    const {theme} = useTheme()
    const {answers} = useContext(SurveyContext)

    const fetchParams = formatFetchParams(answers)

    const {data, isLoading, error} = useFetch<any>(`/results?${fetchParams}}`)

    console.log(answers)

    if (error) {
        return <ErrorWrapper>Il y a un problème</ErrorWrapper>
    }

    const resultsData = data

    return isLoading ? (
        <LoaderWrapper>
            <Loader/>
        </LoaderWrapper>
    ) : (
        <ResultsContainer $theme={theme}>
            <ResultsTitle $theme={theme}>
                Les compétences dont vous avez besoin :
                {resultsData &&
                    resultsData.map((result, index) => (
                        <JobTitle
                            key={`result-title-${index}-${result.title}`}
                            $theme={theme}
                        >
                            {result.title}
                            {index === resultsData.length - 1 ? '' : ','}
                        </JobTitle>
                    ))}
            </ResultsTitle>
            <StyledLink $isFullLink to="/freelances">
                Découvrez nos profils
            </StyledLink>
            <DescriptionWrapper>
                {resultsData &&
                    resultsData.map((result, index) => (
                        <JobDescription
                            $theme={theme}
                            key={`result-detail-${index}-${result.title}`}
                        >
                            <JobTitle $theme={theme}>{result.title}</JobTitle>
                            <p>{result.description}</p>
                        </JobDescription>
                    ))}
            </DescriptionWrapper>
        </ResultsContainer>

    )
}
